import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IComposition, ICompositionAddResponse, ICompositionResponse, ICompositionValidationResponse, IResponseMessage } from '../../models';
import { APIConstants } from '../../common';

@Injectable({
  providedIn: 'root'
})
export class CompositionsService {

  allCompositions: IComposition[] = [];
  playlistCount = 0;

  constructor(private http: HttpClient) { }

  getAllCompositions(hide_quick: boolean = false, playlistType?: string): Observable<ICompositionResponse> {
    const queryParams: string[] = [];
    if (hide_quick) queryParams.push('hide_quick=true');
    if (playlistType) queryParams.push(`playlist_type=${encodeURIComponent(playlistType)}`);

    const url = APIConstants.compositions + (queryParams.length ? `?${queryParams.join('&')}` : '');
    return this.http.get<ICompositionResponse>(url);
  }

  getAllCompositionsByLimit(limit: number, offset: number, hide_quick: boolean, search?: string, ordering?: string): Observable<ICompositionResponse> {
    let url = APIConstants.compositions + '?limit=' + limit + '&offset=' + offset + '&hide_quick=' + hide_quick;
    if (search) {
      url += '&search=' + encodeURIComponent(search);
    }
    if (ordering) {
      url += '&ordering=' + encodeURIComponent(ordering);
    }
    return this.http.get<ICompositionResponse>(url);
  }

  getPlaylistCountList(): Observable<any> {
    return this.http.get<any>(APIConstants.playlistCountList);
  }

  addComposition(composition: FormData): Observable<ICompositionAddResponse> {
    return this.http.post<ICompositionAddResponse>(APIConstants.compositions, composition);
  }

  updateComposition(composition_id: number, composition: FormData): Observable<ICompositionAddResponse> {
    return this.http.put<ICompositionAddResponse>(APIConstants.compositions + composition_id + '/', composition);
  }

  bulkUpdateLauncherPlaylists(playlists: Array<{ id: number; launcher_order: number; is_active: boolean }>): Observable<IResponseMessage> {
    return this.http.put<IResponseMessage>(APIConstants.launcherPlaylistsBulkUpdate, { playlists });
  }

  deleteCompositionById(composition_id: number): Observable<IResponseMessage> {
    return this.http.delete<IResponseMessage>(APIConstants.compositions + composition_id + '/');
  }

  cloneCompositionById(composition_id: number): Observable<IResponseMessage> {
    return this.http.post<IResponseMessage>(APIConstants.cloneComposition, { 'composition_id': composition_id });
  }

  getCompositionById(composition_id: number): Observable<IComposition> {
    return this.http.get<IComposition>(APIConstants.compositions + composition_id + '/');
  }

  getCompositionsByContentId(content_id: number): Observable<IComposition[]> {
    return this.http.get<IComposition[]>(APIConstants.compositionsByContent + content_id + '/');
  }

  deleteMultipleCompositions(composition_ids: number[]): Observable<IResponseMessage> {
    const options = {
      body: { composition_ids: composition_ids }
    };

    return this.http.delete<IResponseMessage>(APIConstants.deleteMultipleCompositions, options);
  }

  validateCompositionDelete(composition_ids: number[]): Observable<ICompositionValidationResponse> {
    return this.http.post<ICompositionValidationResponse>(APIConstants.validateCompositionDelete, { 'composition_ids': composition_ids });
  }

  playlistPreview(composition: FormData): Observable<ICompositionAddResponse> {
    return this.http.post<ICompositionAddResponse>(APIConstants.playlistPreview, composition);
  }
}
